import equalByNameAndAssetComponentId from '../../utils/equalByNameAndAssetComponentId';
import {i18n} from "../../../vue-i18n";

export default class ChangeQuantity {
  constructor(assetComponentId, newQuantity) {
    this.commandName = "ChangeQuantity";

    this.assetComponentId = assetComponentId;
    this.newQuantity = newQuantity;

    this.description =
      `${i18n.t('CONTENT.events.new_quantity')}: ${this.newQuantity}`;

  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        AssetComponentId: this.assetComponentId,
        NewQuantity: this.newQuantity
      })
    }
  }

  equal = (other) => equalByNameAndAssetComponentId(this, other);
}
